import { actionTypes } from '../constants';

const initialState = {
    list: [],
    detail: null,
    is_loaded: false
};

export default (state = initialState, action) => {
    switch(action.type) {
        case actionTypes.DEPARTMENTS_CLEAR_DETAIL:
            return {
                ...state,
                detail: null,
                is_loaded: true,
            }
        case actionTypes.DEPARTMENTS_FETCH_ALL:
            return {
                ...state,
                is_loaded: false,
            }
        case actionTypes.DEPARTMENTS_FETCH_ALL_SUCCESS:
            return {
                ...state,
                list: action.departments,
                is_loaded: true
            }
        case actionTypes.DEPARTMENTS_FETCH_ALL_ERROR:
            return {
                ...state,
                list: [],
                is_loaded: false
            }
        case actionTypes.DEPARTMENTS_FETCH_ONE:
            return {
                ...state,
                is_loaded: false,
            }
        case actionTypes.DEPARTMENTS_FETCH_ONE_SUCCESS:
            return {
                ...state,
                detail: action.detail,
                is_loaded: true
            }
        case actionTypes.DEPARTMENTS_FETCH_ONE_ERROR:
            return {
                ...state,
                detail: null,
                is_loaded: false
            }
        case actionTypes.DEPARTMENTS_UPDATE_ONE:
            return {
                ...state,
            }
        case actionTypes.DEPARTMENTS_UPDATE_ONE_SUCCESS:
            return {
                ...state,
                detail: action.detail,
            }
        case actionTypes.DEPARTMENTS_UPDATE_ONE_ERROR:
            return {
                ...state,
            }
        default:
            return state;
    }
}
